import { Table } from "react-bootstrap";
import styles from "../../styles/Table.module.scss";

const CustomTable = (props) => {
  return (
    <>
      <Table bordered hover className={styles.table}>
        <thead>
          <tr valign="center">
            {props?.data?.table1_headers ? (
              props.data.table1_headers.map((header, index) =>
                index === 0 ? (
                  <th key={index} align="center" valign="middle">
                    {header}
                  </th>
                ) : (
                  <th key={index} align="center" valign="middle">
                    {header}
                  </th>
                )
              )
            ) : (
              <th>Header 1</th>
            )}
          </tr>
        </thead>
        <tbody>
          {props?.data?.table1_rows ? (
            props.data.table1_rows.map((item, index) => (
              <tr key={index}>
                {Object.entries(item).map(([key, value], idx) =>
                  idx === 0 ? (
                    <td
                      align="center"
                      component="th"
                      scope="row"
                      valign="middle"
                      key={idx}
                    >
                      <h3 style={{ fontSize: "16px" }}>{item[key]}</h3>
                    </td>
                  ) : (
                    <td align="center" valign="middle" key={idx}>
                      {item[key]}
                    </td>
                  )
                )}
              </tr>
            ))
          ) : (
            <th>Row 1</th>
          )}
        </tbody>
      </Table>
    </>
  );
};

export default CustomTable;
